import { useState, useEffect } from "react";

import { Loader2 } from "lucide-react";

import { toast } from "@/components/ui/sonner";
import { supabase } from "@/integrations/supabase/client";

import { ActivityHeatMap } from "../dashboard/ActivityHeatMap";
import { ActivityTimeline } from "../dashboard/ActivityTimeline";

interface ProjectActivityViewProps {
  projectId: string;
  projectName: string;
}

export const ProjectActivityView = ({ projectId, projectName }: ProjectActivityViewProps) => {
  const [loading, setLoading] = useState(true);
  const [activityData, setActivityData] = useState<any[]>([]);

  useEffect(() => {
    const fetchProjectActivity = async () => {
      try {
        setLoading(true);

        const { data, error } = await supabase.rpc('get_project_activity_heatmap', {
          p_project_id: projectId,
          p_days_back: 180,
        });

        if (error) throw error;

        setActivityData(data || []);
      } catch (error) {
        console.error('Error fetching project activity:', error);
        toast.error('Failed to load project activity data');
      } finally {
        setLoading(false);
      }
    };

    fetchProjectActivity();
  }, [projectId]);

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <ActivityHeatMap
        data={activityData}
        title={`${projectName} Activity Heat Map`}
        description="Contribution graph showing project activity over the past 6 months"
      />
      <ActivityTimeline
        data={activityData}
        title={`${projectName} Activity Timeline`}
        description="Detailed breakdown of project activity trends"
        showProjects={false}
        showBoards={false}
      />
    </div>
  );
};
